import React from 'react';
import DetalhesImportacaoPage, {
    colunaCliente,
    colunaProcessado,
    colunaErros,
    colunaStatusDetalhe,
} from '../../../components/importacoes/DetalhesImportacaoPage';
import { formatToBrl } from '../../../utils/FormatToBrl';

const columns = [
    colunaCliente,
    colunaProcessado,
    colunaErros,
    { key: 'competencia', label: 'Competência', render: (item) => item?.competencia || '—' },
    { key: 'vencimento', label: 'Vencimento', render: (item) => item?.vencimento || '—' },
    { key: 'valor', label: 'Valor', align: 'right', sx: { fontWeight: 600 }, render: (item) => formatToBrl(item?.valor) },
    colunaStatusDetalhe,
];

const DetalhesImportacao = () => (
    <DetalhesImportacaoPage
        endpoint="detalhes/importacao"
        breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Obrigações', to: '/obrigacoes' }, { label: 'Detalhes da importação' }]}
        columns={columns}
    />
);

export default DetalhesImportacao;
